module.exports = __webpack_public_path__ + "media/images/seller-guide-nikki-15d0d23b0cd3993af95201dd8234e7b8.png";